export const FIELD_TYPES = [
  'auto-id', 'string', 'number', 'boolean', 'timestamp',
  'reference', 'array', 'map', 'url', 'geopoint',
];

export const NODE_TYPES = ['collection', 'subcollection', 'external', 'process', 'note'];

export const RELATIONSHIP_TYPES = ['reference', 'subcollection', 'triggers', 'writes', 'reads', 'mirrors'];

export const NODE_TYPE_CONFIG = {
  collection:    { headerBg: '#1d4ed8', bodyBg: '#0f1f3d', border: '#2563eb', textColor: '#bfdbfe', label: 'Collection' },
  subcollection: { headerBg: '#6d28d9', bodyBg: '#1a0e2e', border: '#7c3aed', textColor: '#ddd6fe', label: 'Subcollection' },
  external:      { headerBg: '#b45309', bodyBg: '#2a1a04', border: '#d97706', textColor: '#fde68a', label: 'External System' },
  process:       { headerBg: '#065f46', bodyBg: '#062016', border: '#059669', textColor: '#a7f3d0', label: 'Process / Function' },
  note:          { headerBg: '#334155', bodyBg: '#1e293b', border: '#475569', textColor: '#cbd5e1', label: 'Note' },
};

export const RELATIONSHIP_CONFIG = {
  reference:     { color: '#64748b', label: 'Reference' },
  subcollection: { color: '#7c3aed', label: 'Subcollection' },
  triggers:      { color: '#d97706', label: 'Triggers' },
  writes:        { color: '#059669', label: 'Writes' },
  reads:         { color: '#2563eb', label: 'Reads' },
  mirrors:       { color: '#db2777', label: 'Mirrors' },
};

export const FIELD_TYPE_ABBR = {
  'auto-id':   'id',
  'string':    'str',
  'number':    'num',
  'boolean':   'bool',
  'timestamp': 'ts',
  'reference': 'ref',
  'array':     'arr',
  'map':       'map',
  'url':       'url',
  'geopoint':  'geo',
};
